import React, { useEffect, useState } from "react";
import { RotatingLines, ThreeDots } from "react-loader-spinner";
import { useAuth } from "../../context/Auth";
import { toast } from "react-toastify";
import WorkInfo from "./WorkInfo";
import GeneralInfo from "./GeneralInfo";

const MemberForm2 = ({
  setPage,
  data,
  handleChange,
  submitting, 
  submitForm,
  workInfo,
  handleWorkInfoChange,
  nextOfKinInfo,
  handleNextOfKinInfoChange,
  emergencyContactInfo,
  handleEmergencyContactInfoChange,
  fatherInfo, 
  motherInfo,
  handleFatherInfoChange,
  handleMotherInfoChange,

  
}) => {
  
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const [available, setAvailable] = useState(false)
  const {requestWithAuth} = useAuth();


  const checkAvailability = async () => {
    setCheckingAvailability(true)
    try {
      const responseData = await requestWithAuth(`/accounts/${data?.username}/availability`, 'GET');
      setAvailable(responseData)
    } catch (error) {
      toast.error("Couldn't set result")
    }finally{
      setCheckingAvailability(false)
    }
  }

  

  useEffect(()=>{
    if(data?.username){
      checkAvailability()
    }
  }, [data?.username])
  return (
    <div className="border border-gray-500">
      {/* FAMILY INFORMATION (CONT'D) */}
      <div className="member-form-section">
        <div className="bg-primary text-secondary px-5 py-2">
          FAMILY INFORMATION (CONT’D)
        </div>
        <div className="member-form-body">
          <div >
            {/* FIRST ROW */}
            <div className="grid lg:grid-cols-3 gap-5 p-5">
              {/* FATHER'S NAME */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Father's Name<span class="text-danger">*</span>
                </label>
                <input
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                  type="text"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.name}
                  name="name"
                  id="name"
                />
              </div>
              {/* FATHER'S CONTACT NUMBER */}
              <div className="flex flex-col">
                <label htmlFor="">Father's Contact Number</label>
                <input
                  type="text"
                  name="contact"
                  id="contact"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.contact}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* ADDRESS */}
              <div className="flex flex-col">
                <label htmlFor="">Address</label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.address}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* FATHER OCCUPATION */}
              <div className="flex flex-col">
                <label htmlFor="">Father's Occupation</label>
                <input
                  type="text"
                  name="occupation"
                  id="occupation"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.occupation}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* FATHER HOMETOWN */}
              <div className="flex flex-col">
                <label htmlFor="">Father's Hometown</label>
                <input
                  type="text"
                  name="hometown"
                  id="hometown"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.hometown}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* FATHER NATIONALITY */}
              <div className="flex flex-col">
                <label htmlFor="">Father's Nationality</label>
                <input
                  type="text"
                  name="nationality"
                  id="nationality"
                  onChange={(e) => handleFatherInfoChange(e)}
                  value={fatherInfo?.nationality}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* MOTHER'S NAME */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Mother's Name <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  onChange={(e) => handleMotherInfoChange(e)}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                  value={motherInfo?.name}
                />
              </div>
              {/* MOTHER'S CONTACT NUMBER */}
              <div className="flex flex-col">
                <label htmlFor="">Mother's Contact Number</label>
                <input
                  type="text"
                  name="contact"
                  id="contact"
                  onChange={(e) => handleMotherInfoChange(e)}
                  value={motherInfo?.contact}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* MOTHER'S ADDRESS */}
              <div className="flex flex-col">
                <label htmlFor="">Mother's Address</label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  onChange={(e) => handleMotherInfoChange(e)}
                  value={motherInfo?.address}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* MOTHER'S OCCUPATION */}
              <div className="flex flex-col">
                <label htmlFor="">Mother's Occupation</label>
                <input
                  type="text"
                  name="occupation"
                  id="occupation"
                  onChange={(e) => handleMotherInfoChange(e)}
                  value={motherInfo?.occupation}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* MOTHER'S HOMETOWN */}
              <div className="flex flex-col">
                <label htmlFor="">Mother's Hometown</label>
                <input
                  type="text"
                  name="hometown"
                  id="hometown"
                  onChange={(e) => handleMotherInfoChange(e)}
                  value={motherInfo?.hometown}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* MOTHER'S NATIONALITY */}
              <div className="flex flex-col">
                <label htmlFor="">Mother's Nationality</label>
                <input
                  type="text"
                  name="nationality"
                  onChange={(e) => handleChange(e)}
                  value={motherInfo?.nationality}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
            </div>
            
            
           
          </div>
        </div>
      </div>

      {/* EDUCATION & WORK INFORMATION */}
      <WorkInfo workInfo ={workInfo} handleWorkInfoChange={handleWorkInfoChange} />

      {/* GENERAL INFORMATION */}
      <GeneralInfo nextOfKinInfo={nextOfKinInfo} handleNextOfKinInfoChange={handleNextOfKinInfoChange} emergencyContactInfo={emergencyContactInfo} handleEmergencyContactInfoChange={handleEmergencyContactInfoChange} />

      {/* ACCOUNT INFORMATION */}
      {/* <div className="member-form-section">
      <div className="bg-primary text-secondary px-5 py-2">ACCOUNT INFORMATION</div>
      <div className="member-form-body">
          <div>
            
            <div className="grid lg:grid-cols-3 gap-5 p-5">
              
              <div className="flex flex-col">
                <label htmlFor="">
                  Username
                  <span class="text-danger">*</span>
                </label>
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="username"
                    id="username"
                    onChange={(e) => handleChange(e)}
                    value={data?.username}
                    className="border border-gray-500 px-3 py-2 outline-none rounded"
                  />
                  {
                    data?.username && (
                      <p>
                        {
                          checkingAvailability ? (
                            <p>Checking availability...</p>
                          ):(
                            <>
                              {
                                available ? (
                                  <p className="text-green-500 font-bold">
                                    {data?.username} is available
                                  </p>
                                ):(
                                  <p className="text-red-500 font-bold">
                                    {data?.username} is not available
                                  </p>
                                )
                              }
                            </>
                          )
                        }
                      </p>
                    )
                  }
                </div>
              </div>
              
              <div className="flex flex-col">
                <label htmlFor="">
                  Preferred Password<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="password"
                  id="password"
                  onChange={(e) => handleChange(e)}
                  value={data?.password}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              
              <div className="flex flex-col">
                <label htmlFor="">
                  Confirm Password<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="confirm_password"
                  id="confirm_password"
                  onChange={(e) => handleChange(e)}
                  value={data?.confirm_password}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              
            </div>
           
          </div>
        </div>
      </div> */}
      {submitting ? (
        <div className="flex justify-end p-5">
          <div className="flex gap-2 p-2 bg-gray-300 rounded">
            <RotatingLines 
              strokeColor="black"
              height="20"
              width="20"
            /> Creating Member
          </div>
        </div>
      ) : (
        <div className="continue-button flex items-center justify-between p-5">
          <div className="default-button" onClick={() => setPage(1)}>
            Previous
          </div>
          <div className="default-button" onClick={(e) => submitForm(e)}>
            Submit
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberForm2;
